import { Injectable } from '@angular/core';
import { Cuestionario, Respuesta, RespuestaTipo, RespuestaTipoOpciones } from './cuestionario/cuestionario.entity';
import { Pregunta } from './cuestionario/cuestionario.entity';
import { Capa } from './solucion/Capa.entity';
import { Dimension } from './solucion/Dimension.entity';
import { Etapa } from './diagnostico/Diagnostico.entity';
// import { Http , Response} from '@angular/http';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class CuestionarioService {

private _capas: Capa[] = [
  {dimensionID: 2 , capaId: 1 , dimension: null , descripcion: 'Estrategia de Valor'},
  {dimensionID: 2 , capaId: 2 , dimension: null , descripcion: 'Plan operativo'},
  {dimensionID: 3 , capaId: 3 , dimension: null , descripcion: 'Procesos Críticos'},
  {dimensionID: 3 , capaId: 4 , dimension: null , descripcion: 'Integración transversal '},
  {dimensionID: 4 , capaId: 5 , dimension: null , descripcion: 'Diseño organizativo'},
  {dimensionID: 4 , capaId: 6 , dimension: null , descripcion: 'Capacidad'},
  {dimensionID: 5 , capaId: 7 , dimension: null , descripcion: 'Creencias y supuestos'},
  {dimensionID: 5 , capaId: 8 , dimension: null , descripcion: 'Comportamientos'}
];

private _dimensiones: Dimension[] = [
  {dimensionID: 1 , descripcion: 'Propósito, Visión, Valores', leyenda: '', leyenda2: '', isCompleted: false},
  {dimensionID: 2 , descripcion: 'sentido de dirección', leyenda: '', leyenda2: '', isCompleted: false},
  {dimensionID: 3 , descripcion: 'Entrega de Valor', leyenda: '', leyenda2: '', isCompleted: false},
  {dimensionID: 4 , descripcion: 'Diseño organizativo y capacidad', leyenda: '', leyenda2: '', isCompleted: false},
  {dimensionID: 5 , descripcion: 'Cultura y Comportamientos', leyenda: '', leyenda2: '', isCompleted: false},
  {dimensionID: 6 , descripcion: 'Liderazgo', leyenda: '', leyenda2: '', isCompleted: false} ];

  private _preguntas: Pregunta[] = [
  {preguntasID: 1  , dimensionID: 1  , capaId: null  , descripcion: '¿Existe un Propósito (Misión) compartida por toda la organización? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
     etapaID: 3  , etapa: null , completa: false  },
  {preguntasID: 2  , dimensionID: 1  , capaId: null  ,
    descripcion: '¿Es verdaderamente trascendente como para alentar la capacidad de entrega y para dar sentido al esfuerzo? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 3  , dimensionID: 1  , capaId: null  , descripcion: '¿Existe una Visión de futuro compartida por toda la organización? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 4  , dimensionID: 1  , capaId: null  ,
     descripcion: '¿Es inspiradora y lo suficientemente “grande” como para generar energía y mover a la acción? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 5  , dimensionID: 1  , capaId: null  ,
     descripcion: '¿Los valores y principios de actuación son consistentes con la propuesta de valor al cliente? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 6  , dimensionID: 1  , capaId: null  , descripcion: '¿Son compartidos y se trasladan a los comportamientos y  decisiones? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 7  , dimensionID: 2  , capaId: 1  , descripcion:
    '¿Hay un conocimiento y comprensión profunda de las expectativas actuales y futuras de los clientes?  '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 8  , dimensionID: 2  , capaId: 1  ,
     descripcion: '¿Los clientes reconocen que la propuesta de valor es única y diferencial con respecto a los competidores ?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
  {preguntasID: 9  , dimensionID: 2  , capaId: 1  ,
     descripcion: '¿Los lineamientos e iniciativas estratégicas están definidas y han sido compartidos con toda la organización? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 10  , dimensionID: 2  , capaId: 2  ,
   descripcion: '¿Los planes de corto plazo están alineados con la estrategia y visión de largo plazo?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 11  , dimensionID: 2  , capaId: 2  , descripcion: '¿Los planes y prioridades de cada área están definidos y alineados? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 12  , dimensionID: 2  , capaId: 2  , descripcion: '¿Hay un sistema de gobierno que asegura disciplina en la ejecución?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 13  , dimensionID: 3  , capaId: 3  ,
   descripcion: 'Está descripto el ciclo completo de la experiencia de cliente y los momentos de verdad'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 14  , dimensionID: 3  , capaId: 3  , descripcion: 'Están identificados y definidos los procesos críticos? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 15  , dimensionID: 3  , capaId: 3  ,
   descripcion: 'La tecnología y los procesos favorecen la simplicidad, agilidad y  eficiencia de ejecución'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 16  , dimensionID: 3  , capaId: 4  ,
   descripcion: 'Se trabaja integradamente en la gestión de los procesos críticos que alimentan la experiencia de cliente'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 17  , dimensionID: 3  , capaId: 4  ,
   descripcion: 'Se han alineado e integrado a stakeholders clave – contratistas, proveedores- a los procesos de trabajo'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 18  , dimensionID: 3  , capaId: 4  , descripcion: 'Todos saben cómo contribuir a crear esa diferencia '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 19  , dimensionID: 4  , capaId: 5  ,
  descripcion: 'El diseño de la organización ¿favorece simplicidad, agilidad y autonomía en la toma de decisiones?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 20  , dimensionID: 4  , capaId: 5  , descripcion: 'La cantidad de niveles ejecutivos, responde a la complejidad a gestionar?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 21  , dimensionID: 4  , capaId: 5  , descripcion: 'Los roles y responsabilidades están claramente definidos'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
    etapaID: 3  , etapa: null , completa: false},
{preguntasID: 22  , dimensionID: 4  , capaId: 6  , descripcion: 'Las capacidades son acordes a la complejidad a gestionar? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 23  , dimensionID: 4  , capaId: 6  , descripcion: 'Está la gente correcta en el lugar correcto?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 24  , dimensionID: 4  , capaId: 6  ,
   descripcion: 'Está identificado y hay un pleno aprovechamiento del talento de la organización? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 25  , dimensionID: 5  , capaId: 7  ,
   descripcion: 'Las creencias y supuestos que definen las fórmulas de éxito, ¿están alineados a la estrategia? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 26  , dimensionID: 5  , capaId: 7  ,
   descripcion: 'La cultura es flexible y abierta? Permite desafiar paradigmas y favorecer la innovación?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 27  , dimensionID: 5  , capaId: 7  ,
   descripcion: 'Las creencias de la gente acerca de lo que está bien o mal hecho responden a la creación de valor?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 28  , dimensionID: 5  , capaId: 8  , descripcion: 'Hay coherencia entre el decir y el hacer?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,   respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false },
{preguntasID: 29  , dimensionID: 5  , capaId: 8  , descripcion: 'El comportamiento está enfocado en crear valor para el cliente?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,  respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false },
{preguntasID: 30  , dimensionID: 5  , capaId: 8  ,
   descripcion: 'Se trabaja en colaboración con un entendimiento punta a punta del impacto de la tarea en el resultado?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,  respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 31  , dimensionID: 6  , capaId: null   , descripcion: 'Inspiran y hacen vivir la Visión, Propósito y Valores'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1, respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 32  , dimensionID: 6  , capaId: null  ,
   descripcion: 'Nuestros líderes alinean involucrándose en la definición de objetivos y prioridades de ejecución'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1, respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 33  , dimensionID: 6  , capaId: null   , descripcion: 'Definen responsabilidades claras acordes a la capacidad'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1, respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 34  , dimensionID: 6  , capaId: null  ,
   descripcion: 'Enfocan el desempeño en las tareas de mayor contribución y proveen reconocimiento asociado al mérito?'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1, respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 35  , dimensionID: 6  , capaId: null  ,
   descripcion: 'Crean condiciones habilitadoras para que se ejerza autonomía con responsabilidad? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,  respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
{preguntasID: 36  , dimensionID: 6  , capaId: null  ,
   descripcion: 'Gestionan el contexto y potencian las capacidades para trabajar de manera ágil y colaborativa? '
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 1,  respuestaTipo:  null,
   etapaID: 3  , etapa: null , completa: false},
 {preguntasID: 37  , dimensionID: null  , capaId: null  ,
    descripcion: 'Selecciona el estado de tu organización'
   , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 2,  respuestaTipo:  null,
    etapaID: 1  , etapa: null , completa: false},
  {preguntasID: 38  , dimensionID: null  , capaId: null  ,
  descripcion: 'Dónde están ahora y hacia dónde quieren llegar:'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 3, respuestaTipo: null,
  etapaID: 2  , etapa: null , completa: false},
  {preguntasID: 39  , dimensionID: null  , capaId: null  ,
  descripcion: 'Dónde están ahora y hacia dónde quieren llegar:'
  , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 3, respuestaTipo: null,
  etapaID: 2  , etapa: null , completa: false},
  {preguntasID: 40  , dimensionID: null  , capaId: null  ,
    descripcion: 'Dónde están ahora y hacia dónde quieren llegar:'
    , dimension: null,  capa: null,  AyudaID: null,  activa: true,  respuestaTipoID: 3, respuestaTipo: null,
    etapaID: 2  , etapa: null , completa: false}
  ];
  private _respuestaTipo: RespuestaTipo[] = [
    {respuestaTipoID: 1 , respuestaDescripcion: 'Semaforo', respuestaTipoEnum: 1},
    {respuestaTipoID: 2 , respuestaDescripcion: 'Opciones del Cambio', respuestaTipoEnum: 2},
    {respuestaTipoID: 3 , respuestaDescripcion: 'Donde estamos', respuestaTipoEnum: 3} ];

    // Para las opciones del semaforo falta guardar la clase asociada y la imagen del semaforo.
    private _respuestaTipoOpciones: RespuestaTipoOpciones[] = [
      {respuestaTipoOpcionID: 1, respuestaTipoID: 1 , respuestaOpcion: 'Si'},
      {respuestaTipoOpcionID: 2, respuestaTipoID: 1 , respuestaOpcion: 'Mas o Menos'},
      {respuestaTipoOpcionID: 3, respuestaTipoID: 1 , respuestaOpcion: 'No'},
      {respuestaTipoOpcionID: 4, respuestaTipoID: 2 , respuestaOpcion: 'Estamos creciendo en forma acelerada'},
      {respuestaTipoOpcionID: 5, respuestaTipoID: 2 , respuestaOpcion: 'Es una fusión de empresas'},
      {respuestaTipoOpcionID: 6, respuestaTipoID: 2 , respuestaOpcion: 'El negocio cambio, nos estamos re adaptando al nuevo esquema'},
      {respuestaTipoOpcionID: 7, respuestaTipoID: 2 , respuestaOpcion: 'No estamos en un proceso de cambio'},
      {respuestaTipoOpcionID: 8, respuestaTipoID: 3 , respuestaOpcion: 'De'},
      {respuestaTipoOpcionID: 9, respuestaTipoID: 3 , respuestaOpcion: 'Hacia'}, ];

    private _etapas: Etapa[] = [
      {etapaId: 1 , descripcion: 'DESAFÍOS DE NEGOCIO',
       leyenda: '¿Qué desafíos de negocio enfrenta actualmente?',
       leyenda2: 'Selecciona el estado de tu organización.', hasChild: false , isCompleted: false} ,
      {etapaId: 2 , descripcion: 'CAMBIOS'  ,
       leyenda: '¿Cuáles son los cambios que están viviendo actualmente? ' ,
       leyenda2: 'Describe al menos 3 cambios que reflejen dónde están ahora ' +
       'y hacia dónde quieren llegar.', hasChild: false, isCompleted: false },
      {etapaId: 3 , descripcion: 'DIMENSIONES' , leyenda: '', leyenda2: '', hasChild: true , isCompleted: false },
      {etapaId: 4 , descripcion: 'DESCONEXIONES' , leyenda: '', leyenda2: '', hasChild: false, isCompleted: false  },
      {etapaId: 5 , descripcion: 'SOLUCIONES' , leyenda: '', leyenda2: '', hasChild: false , isCompleted: false }
    ];


    public _respuestas: Respuesta[] = [];

    constructor() {
     }

    GetAllEtapas(): Etapa[] {
     return this._etapas;
   }

  GetAllDimensiones(): Dimension[] {
    return this._dimensiones;
  }
  GetAll(): Pregunta[] {
    this._preguntas.forEach(element => {
      element.dimension = this._dimensiones.filter(x => x.dimensionID === element.dimensionID)[0];
      element.capa = this._capas.filter(x => x.capaId === element.capaId)[0];
      element.etapa = this._etapas.filter(x => x.etapaId === element.etapaID)[0];
      element.respuestaTipo = this._respuestaTipo.filter(x => x.respuestaTipoID === element.respuestaTipoID)[0];
    });
    return this._preguntas;
  }
  GetbyEtapa(etapaID: number): Pregunta[] {
    return this._preguntas
                .filter( a => a.etapaID === etapaID);
  }
  GetbyDimension(dimensionID: number): Pregunta[] {
    return this._preguntas
                .filter( a => a.dimensionID === dimensionID);
  }

  Get(id: number): Pregunta {
    const  index = this._preguntas.findIndex( (a) => a.preguntasID === id);
    if (index < 0) {
      return null;
    }
    return this._preguntas[index];
  }

  GetRespuesta(id: number): Respuesta {
    let result: Respuesta = null;
    if (this._respuestas != null) {
      // alert(id);
      const  index = this._respuestas.findIndex( (a) => a.preguntasID === id);
      // alert(index);
      if (index < 0) {
        result = null;
      }
      result = this._respuestas[index];
    }
    return result;
  }
  GetRespuestaTipoOpciones(respuestaTipoID: number): RespuestaTipoOpciones[] {
    return  this._respuestaTipoOpciones.filter( (a) => a.respuestaTipoID === respuestaTipoID);
  }
  Add(pregunta: Pregunta): number {

    pregunta.preguntasID = new Date().valueOf(); // "unique" id
    this._preguntas.push(pregunta);
    return pregunta.preguntasID;
  }

  Delete(id: number): void {

    const  index = this._preguntas.findIndex( (a) => a.preguntasID === id);
    this._preguntas.splice(index, 1);

  }

  Update(pregunta: Pregunta) {
    const  index = this._preguntas.findIndex( (a) => a.preguntasID === pregunta.preguntasID);
    if (index >= 0) {
      this._preguntas[index] = pregunta;
    } else {
      throw  new Error('Pregunta inexistente');
    }
  }

  FindbyDescripcion(nombre: string): Pregunta[] {
    return this._preguntas
                .filter( a => (a.descripcion ).toLowerCase().indexOf(nombre.toLocaleLowerCase()) >= 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/cuestionario.service.ts